import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setSelectedMenu,
  setSelectedMenuId,
} from "../../redux/features/appData/appDataSlice";
import Modal from "../shared/Modal";
import "./ModalHRISRequired.css";

type ModalHRISRequiredProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalHRISRequired = ({
  isOpen,
  onClose,
  onContinue,
}: ModalHRISRequiredProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-hris-required">
          <div className="modal-hris-required-title">HRIS Required</div>

          <div className="modal-hris-required-content">
            <p>
              This requires an HRIS to be connected. Please connect your
              workspace.
            </p>
          </div>

          <div className="modal-hris-required-footer">
            <div className="modal-hris-required-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => {
                  navigate("/workspaces?tab=4");
                  dispatch(setSelectedMenu(null));
                  dispatch(setSelectedMenuId(null));
                }}
                className="collections-button">
                Connect HRIS
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalHRISRequired;
